<style lang="less" scoped>
    .modal {
        /deep/.ivu-modal-body {
            min-height: 0;
        }
    }
</style>
<template>
  <div>
    <Modal
      v-model="showModal"
      class="modal"
      title="提示"
      :closable="false"
    >
      <p>
        {{ formProps.del?'是否启用该条目':'是否禁止该条目' }}
      </p>
      <div slot="footer">
        <Button
          @click="cancel"
        >
          取消
        </Button>
        <Button
          type="primary"
          :loading="loading"
          @click="ok"
        >
          确定
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
    export default {
        props: {
            display: {
                type: Boolean,
                default:() => false
            },
            formProps: {
              type:Object,
              default:() => ({})
            },
            loading:{
                type:Boolean,
                default:() => false
            }
        },
        data () {
            return {
                showModal: false
            }
        },
        watch: {
            display (value) {
               this.showModal = value
            }
        },
        methods: {
            ok () {
                this.$emit('ok',{...this.formProps,del:!this.formProps.del}) 
            },
            cancel () {
                this.$emit('cancel')
            }
        }
    }
</script>
